export default "__VITE_ASSET__8M$VVygL__"